const env = {
  LOGIN_WINDOWS_NET: process.env.LOGIN_WINDOWS_NET,
  AUTH_TOKEN_URI: process.env.AUTH_TOKEN_URI,
  REFRESH_TOKEN_URI: process.env.REFRESH_TOKEN_URI,
  OBEX_RESOURCE_URI: process.env.OBEX_RESOURCE_URI,
  OBEX_WEBSERVICE_URI: process.env.OBEX_WEBSERVICE_URI,
  OBEX_TENANT: process.env.OBEX_TENANT,
  OBEX_CLIENT_ID: process.env.OBEX_CLIENT_ID,
  OBEX_NODEJS_USERNAME: process.env.OBEX_NODEJS_USERNAME,
  OBEX_NODEJS_PASSWORD: process.env.OBEX_NODEJS_PASSWORD,
  OBEX_NOTIFICATION_USERNAME: process.env.OBEX_NOTIFICATION_USERNAME,
  OBEX_NOTIFICATION_PASSWORD: process.env.OBEX_NOTIFICATION_PASSWORD,
  OBEX_NOTIFICATION_URI: process.env.OBEX_NOTIFICATION_URI,
  TWILIO_SID: process.env.TWILIO_SID,
  TWILIO_TOKEN: process.env.TWILIO_TOKEN,
  TWILIO_NUMBER: process.env.TWILIO_NUMBER,
  INDEX_FILE: process.env.INDEX_FILE,
  APNS_PROD: process.env.APNS_PROD,
  FB_PAGE_ACCESS_TOKEN: process.env.FB_PAGE_ACCESS_TOKEN,
  API_AI_ACCESS_TOKEN: process.env.API_AI_ACCESS_TOKEN,
  WEBHOOK_HOSTNAME: process.env.WEBHOOK_HOSTNAME,
  BASIC_AUTH: process.env.BASIC_AUTH,
  AGENT_PORTAL_URL: process.env.AGENT_PORTAL_URL
};

module.exports = Object.freeze(env);

//OBEX_TENANT: 'cb454b68-a036-4dd5-a134-ebd4cdad4fe2',
//OBEX_WEBSERVICE_URI: 'https://api.obexsolutions.com',



//////////////////
// WEBPACK FOOTER
// ./server/constants.js
// module id = 227
// module chunks = 0